import { ThemeProvider } from "@emotion/react";
import { legionTheme } from "@legion-ui/core";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { GoogleOAuthProvider } from "@react-oauth/google";

// routes
import { APP_ROUTES } from "./routes";

export const App = () => {
  return (
    <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_OAUTH_ID}>
      <ThemeProvider theme={legionTheme}>
        <Router>
          <Routes>
            {APP_ROUTES.map((APP_ROUTE) => (
              <Route
                key={APP_ROUTE.path}
                path={APP_ROUTE.path}
                element={<APP_ROUTE.element />}
              />
            ))}
          </Routes>
        </Router>
      </ThemeProvider>
    </GoogleOAuthProvider>
  );
};
